import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	priorityChangedContent: {
		id: 'contextual-summary.gadgets.activity-feed.activity-items.attachment-added.priority-changed-content',
		defaultMessage:
			'{author} changed the Priority from {oldPriority} to {newPriority} on {issueLink}',
		description: 'Message shape for an activity item describing a priority change on an issue.',
	},
});
